import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		root: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(3),
		},
		section: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(2),
		},
		// "Customize Widget" and "Embed Code" are Web/H5 (18/700) in the Figma (`3257:15056`, `3258:15112`).
		// That departs from the kit, which gives modal sub-heads 16/700 (as `edit-page-dialog` does): kept
		// on purpose, because here they head the modal's two sections. The field groups inside are 16/700.
		subHead: {
			fontSize: 18,
			fontWeight: 700,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
	} satisfies Record<string, CSSObject>);
};
